import { inputInitState } from "./init_state";
import * as ActionTypes from "../actions/action_type";

const initialStete = {
  stores: {
    data: inputInitState,
  },
};
export const assign_view_info = (state = initialStete, action) => {
  switch (action.type) {
    case ActionTypes.getAssignViewSuccessAction: {
      return { ...state, stores: action.payload };
    }
    case ActionTypes.getAssignViewFailAction:
    case ActionTypes.getAssignViewResetAction:
      return { ...state, stores: initialStete.stores };
    default:
      return state;
  }
};
